import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  linkText: {
    color: 'inherit',
    fontSize: '1rem',
    textDecoration: 'none'
  }
}));

export default useStyles;
